module.exports = __webpack_public_path__ + "static/img/6.0c5113b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/毕业照/6.jpg
// module id = aX7o
// module chunks = 0